module.exports = __webpack_public_path__ + "media/images/block 2-90a0c45a6e93f0f0948418708d1d2f4e.svg";